
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayAnalogOpen as ObiThreewayAnalogOpenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-analog-open.js';
 
 
 

 
 export const ObiThreewayAnalogOpen = createComponent({
   react: React,
   tagName: 'obi-threeway-analog-open',
   elementClass: ObiThreewayAnalogOpenElement,
   events: {
     
   }
  });
 
 